import { STATUS_LABELS, type InvoiceStatus } from '@easiibill/invoice-engine';
import { Badge, type BadgeTone } from './ui/display';

export const STATUS_TONES: Record<InvoiceStatus, BadgeTone> = {
  draft: 'neutral',
  sent: 'info',
  viewed: 'violet',
  partially_paid: 'warning',
  paid: 'success',
  overdue: 'danger',
  cancelled: 'neutral',
  void: 'neutral',
};

export const STATUS_COLORS: Record<InvoiceStatus, string> = {
  draft: '#94a3b8',
  sent: '#0ea5e9',
  viewed: '#8b5cf6',
  partially_paid: '#f59e0b',
  paid: '#10b981',
  overdue: '#f43f5e',
  cancelled: '#cbd5e1',
  void: '#64748b',
};

export function StatusBadge({ status, className }: { status: InvoiceStatus; className?: string }) {
  return (
    <Badge
      tone={STATUS_TONES[status]}
      dot
      className={
        status === 'void' || status === 'cancelled'
          ? `line-through decoration-1 ${className ?? ''}`
          : className
      }
    >
      {STATUS_LABELS[status]}
    </Badge>
  );
}
